import React from "react";

// Bootstrap
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

// Custom Components
import RotatingIcon from "../RotatingIcon";
import SectionTitle from "../SectionTitle";

// Icons
import { FaBook, FaEye, FaHeart } from "react-icons/fa";

// React Scroll
import { Element } from "react-scroll";

import "./styles.css";

const About = () => {
    const items = [
        {
            Icon: FaBook,
            title: "Missão",
            content:
                "Encantar nossos clientes através de soluções inovadoras em tecnologia que impactem a vida das pessoas.",
        },
        {
            Icon: FaEye,
            title: "Visão",
            content:
                "Líderes unidos, comprometidos e capazes de proporcionar experiências transformadoras por meio da vivência empresarial.",
        },
        {
            Icon: FaHeart,
            title: "Valores",
            type: "list",
            content: [
                "Sede de Conhecimento",
                "Orgulho de ser EJEC",
                "Engajamento",
                "Senso de Urgência",
                "Reconhecer o Movimento",
                "Responsabilidade",
            ],
        },
    ];

    return (
        <Element name="about" className="about-section">
            <Container as="main" className="text-center">
                <Row>
                    <SectionTitle>Quem Somos</SectionTitle>
                    <p className="subtitle">
                        A EJEC é uma empresa formada por graduandos do curso de
                        Engenharia de Computação da Universidade Federal de
                        Santa Catarina, que trabalham voluntariamente em
                        projetos para micro e pequenas empresas, otimizando seus
                        processos e aumentando sua visibilidade no mercado.
                        Especializada em desenvolvimento de sites, blogs,
                        sistemas e aplicativos móveis, a EJEC tem sua sede no
                        Campus da UFSC em Araranguá.
                    </p>
                </Row>
                <Row className="items-row">
                    {items.map((item) => (
                        <Col
                            md="4"
                            key={item.title}
                            className="rotation-activator d-flex flex-row"
                        >
                            <div>
                                <RotatingIcon
                                    title={`${item.title} da EJEC`}
                                    Icon={item.Icon}
                                />
                            </div>
                            <div className="item-box-info">
                                <h4>{item.title}</h4>
                                {item.type === "list" ? (
                                    <ul>
                                        {item.content.map((listItem, index) => (
                                            <li key={`list-item-${index}`}>
                                                {listItem}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>{item.content}</p>
                                )}
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Element>
    );
};

export default About;
